import { Menu } from "lucide-react";
import { cn } from "~/lib/utils";
import { AppSidebar } from "./sidebar";
import { SidebarProvider, useSidebar } from "./sidebar-context";

interface AppLayoutProps {
	title?: string;
	titleActions?: React.ReactNode;
	children: React.ReactNode;
}

function AppLayoutInner({ title, titleActions, children }: AppLayoutProps) {
	const { toggle } = useSidebar();

	return (
		<div className="app-glass-canvas relative flex min-h-screen overflow-x-hidden">
			<AppSidebar />
			<main id="main-content" className="relative z-0 min-w-0 flex-1 md:ml-[17.5rem]">
				<div
					className={cn(
						"glass-panel-strong sticky top-3 z-20 mx-3 mt-3 flex flex-wrap items-center justify-between gap-2 rounded-2xl px-4 py-3 md:mx-5 md:px-5",
						!title && "md:hidden",
					)}
				>
					<div className="flex items-center gap-3">
						<button
							type="button"
							onClick={toggle}
							aria-label="Otevřít menu"
							className="glass-control flex h-9 w-9 items-center justify-center rounded-full text-muted transition-colors hover:text-text md:hidden"
						>
							<Menu className="h-5 w-5" />
						</button>
						{title && <h1 className="text-sm font-semibold md:text-base">{title}</h1>}
					</div>
					{title && titleActions}
				</div>
				<div className="p-3 pb-8 md:p-5 lg:p-6">{children}</div>
			</main>
		</div>
	);
}

export function AppLayout(props: AppLayoutProps) {
	return (
		<SidebarProvider>
			<AppLayoutInner {...props} />
		</SidebarProvider>
	);
}
